import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { CONFIG } from '../interceptors/loader.interceptor';
import { HttpContextConfig } from '../models/http-context-config';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable, of } from 'rxjs';
import { SoftSkills } from '../models/softSkills';

const usersURL = `${environment.api}/users/`;
const projectsURL = `${environment.api}/projects/`;
const assignURL = `${environment.api}/assignmentroles/`;
const projectUserURL = `${environment.api}/projectUser/`;
const profURL = `${environment.api}/profs`;
const argumentsURL = `${environment.api}/arguments/`;
const categoriesURL = `${environment.api}/teamcategories/`;
const allocationURL = `${environment.api}/allocations/`;

@Injectable({
  providedIn: 'root'
})
export class AdminSettingsService {
  constructor(private readonly http: HttpClient) {}

  myProjects() {
    return this.http.get<any>(projectsURL + 'myTeamData');
  }

  teamCategories() {
    return this.http.get<any>(categoriesURL + 'index');
  }

  updateTeamCategory(idTypology: any, typology: FormData): Observable<any> {
    return this.http.post<any>(
      categoriesURL + `${idTypology}/update`,
      typology
    );
  }

  updateSprints(id: number, newCategory: number) {
    const data = {
      oldTeamcategory: id,
      newTeamcategory: newCategory
    };
    return this.http.post<any>(categoriesURL + 'updateSprints', data);
  }

  createTeamCategory(typology: FormData): Observable<any> {
    return this.http.post<any>(categoriesURL + `store`, typology);
  }

  deleteTeamCategory(typology_id: any): Observable<any> {
    return this.http.delete<any>(categoriesURL + `${typology_id}/destroy`);
  }

  getAvaibleForAdd(project_id: any, params?: any) {
    let config = new HttpContextConfig();
    config.noSpinner = true;
    const context = new HttpContext().set(CONFIG, config);

    return this.http.get<any>(
      projectUserURL + `${project_id}/avaibleForAddUsers`,
      { params, context }
    );
  }

  /* DA MODIFICARE CON I FILTRI */
  // getUsers(params?: any) {
  //   let config = new HttpContextConfig();
  //   config.noSpinner = true;

  //   return this.http.get<any>(usersURL + 'index/' , { params, context: new HttpContext().set(CONFIG, config) });
  // }

  getAssignmentrole() {
    return this.http.get<any>(assignURL + 'indexTeamRoles');
  }

  addMember(data: any): Observable<any> {
    return this.http.post<any>(projectUserURL + 'store', data);
  }

  updateMember(data: any): Observable<any> {
    return this.http.put<any>(
      projectUserURL + `${data.project_user_id}/update`,
      data
    );
  }

  endWork(data: any): Observable<any> {
    return this.http.patch<any>(
      projectUserURL + `${data.project_user_id}/endWork`,
      data
    );
  }

  destroyMember(project_user_id: any): Observable<any> {
    return this.http.delete<any>(projectUserURL + `${project_user_id}/destroy`);
  }

  /* CHIAMATE GESTIONE PROFESSORI */

  /**
   *
   * @param filters {
                      'filter_search': string,
                      'micro_argument_id': number,
                      'macro_argument_id': number,
                    };
   * @returns  tutti i dati dei professori con relativi argomenti assegnati
   */
  getProfData(filters: any): Observable<any> {
    return of({ result: [] });
  }

  /**
   *
   * @param data  [
                    'user_id' => string,
                    'microarguments_id.*' => integer
                  ];
   * @returns
   */
  toggleProf(data: any): Observable<any> {
    return this.http.post<any>(profURL + `/toggleProf`, data);
  }

  delProf(user_id: string): Observable<any> {
    return of({ result: null });
  }

  getAvailableArg(user_id: string, filter_search: string, argument_id = '') {
    let config = new HttpContextConfig();
    config.noSpinner = true;
    const context = new HttpContext().set(CONFIG, config);

    return this.http.get<any>(argumentsURL + `cardArgument`, {
      params: new HttpParams()
        .set('user_id', user_id)
        .set('argument_id', argument_id)
        .set('filter_search', filter_search),
      context
    });
  }

  getAllocation(flag?: boolean) {
    if (!flag) {
      let config = new HttpContextConfig();
      config.noSpinner = true;
      const context = new HttpContext().set(CONFIG, config);
      return of({ result: [] });
    } else {
      return of({ result: [] });
    }
  }

  getUserAllocation(id: string) {
    return of({ result: null });
  }

  updateMultipleDay(data: any) {
    return of({ result: data });
  }

  changeAllocation(
    id: number,
    new_allocation: number,
    flag?: boolean
  ): Observable<any> {
    let data = { id: id, new_allocation: new_allocation };
    if (!flag) {
      let config = new HttpContextConfig();
      config.noSpinner = true;
      const context = new HttpContext().set(CONFIG, config);
      return of({ result: data });
    } else {
      return of({ result: data });
    }
  }

  getProject(body?: any) {
    return this.http.post<any>(projectsURL + 'index', body);
  }

  deleteMultiDay(multiRange: any) {
    return of({ result: null });
  }

  /**
   * Service per ricavare tutte le soft skills (index)
   * @returns
   */
  getSoftSkills(): Observable<any> {
    return of({ result: [] });
  }

  /**
   * Service per creare una nuova soft skill
   * @param softSkill la soft skill da creare con i relativi dati:
   *                  `id`: number,
   *                  `alias`: string,
   *                  `description`: string,
   *                  `acronym`: string
   *                  `img_file`: string
   */
  addSoftSkill(softSkill: any): Observable<any> {
    return of({ result: softSkill });
  }

  /**
   * Service per modificare le caratteristiche di un soft skill
   * @param id l'id della soft skill da modificare
   * @param formData i dati della soft skill da modificare
   */
  updateSoftSkill(id: number, formData: FormData): Observable<any> {
    return of({ result: formData });
  }

  /**
   * Service per eliminare una soft skill
   */
  deleteSoftSkill(id: number): Observable<SoftSkills> {
    return this.http.delete<SoftSkills>(`${argumentsURL}${id}/destroy`);
  }
}
